import React, {ReactNode} from "react";
import {Route, Routes} from "react-router-dom";
import {AccountTransactionsPage} from "@/page/AccountTransactionsPage";
import {AccountsPage} from "@/page/AccountsPage";
import {SearchTransactionPage} from "@/page/SearchTransactionPage";
import {LoginPage} from "@/page/LoginPage";
import {RequireAuth} from "@/component/RequireAuth";
import {MainPage} from "@/page/MainPage";
import {DialogProvider} from "@/dialog/DialogContext";
import {GlobalDialogs} from "@/dialog/GlobalDialogs";
import {useSession} from "@/hook/useSession";
import {TransLimitsPage} from "@/page/TransLimitsPage";
import {MonthlySummaryPage} from "@/page/MonthlySummaryPage";
import {MemoPage} from "@/page/MemoPage";
import {CloseCardPage} from "@/page/CloseCardPage";
import {Device} from "@/store/Device";
import {MobilePage} from "@/component/layout/MobilePage";
import {PcPage} from "@/component/layout/PcPage";

function ResponsivePage({children} : {children: ReactNode}) {
    return Device.isMobile
        ? <MobilePage>{children}</MobilePage>
        : <PcPage>{children}</PcPage>
}

export function App() {
    const session = useSession();

    return (
        <DialogProvider>
            {session ? (
                <RequireAuth>
                    <ResponsivePage>
                        <Routes>
                            <Route
                                path="/accounts/:accountId/transactions"
                                element={<AccountTransactionsPage/>}
                            />
                            <Route path="/accounts" element={<AccountsPage/>}/>
                            <Route path="/transactions" element={<SearchTransactionPage/>}/>
                            <Route path="/TransLimit" element={<TransLimitsPage/>}/>
                            <Route path="/MonthlySummary" element={<MonthlySummaryPage/>}/>
                            <Route path="/Account/:accountId/closeCard" element={<CloseCardPage/>}/>
                            <Route path="/Memo" element={<MemoPage/>}/>
                            <Route path="/" element={<MainPage/>}/>
                        </Routes>
                    </ResponsivePage>
                </RequireAuth>
            ) : (
                <LoginPage/>
            )}
            <GlobalDialogs/>
        </DialogProvider>
    );
}
